import { lazy } from 'react';
import type { ToolConfig } from '@/types/tool';

export const jsonFormatterConfig: ToolConfig = {
  id: 'json-formatter',
  path: '/tools/json-formatter',
  meta: {
    title: 'JSON Formatter',
    description: 'Advanced JSON formatter with RFC compliance, auto-fix, and TOON view for compact LLM context. 100% client-side.',
    keywords: ['json', 'formatter', 'validator', 'fixer', 'rfc-8259', 'toon', 'toon-view', 'llm-context'],
    icon: 'FileJson',
    category: 'data',
    featured: true,
    gradient: 'from-blue-500 to-cyan-600',
  },
  component: lazy(() => import('./JsonFormatter')),
};
